export default __webpack_public_path__ + "static/media/Desktop-ModelS.ed66ecac.jpg";